import { ROUTES } from "../utils/constants";

export const NullishValues = ["", undefined, null, 0, NaN];

export const meetingFilter = [
  {
    displayName: "Discussion",
    value: "DISCUSSION_MEETING",
  },
  {
    displayName: "Gosho",
    value: "GOSHO_MEETING",
  },
  {
    displayName: "Cubs",
    value: "CUBS_MEETING",
  },
  {
    displayName: "Young Pheonix",
    value: "YP_MEETING",
  },
  {
    displayName: "Young Lion",
    value: "YL_MEETING",
  },
  {
    displayName: "Student",
    value: "SD_MEETING",
  },
];

export const MeetingTypes = [
  {
    displayName: "Discussion",
    value: "DISCUSSION_MEETING",
  },
  {
    displayName: "Gosho",
    value: "GOSHO_MEETING",
  },
];

export const RegionMeetingTypes = [
  {
    displayName: "Cubs Division Meeting",
    value: "CUBS_MEETING",
  },
  {
    displayName: "Young Pheonix Meeting",
    value: "YP_MEETING",
  },
  {
    displayName: "Young Lion Meeting",
    value: "YL_MEETING",
  },
  {
    displayName: "Student Division Meeting",
    value: "SD_MEETING",
  },
];
export const OtherMeetingTypes = [
  {
    displayName: "New Friends Meeting",
    value: "OTHER_MEETING_NEW_FRIENDS",
  },
  {
    displayName: "Education Division Meeting",
    value: "OTHER_MEETING_EDUCATION_DIVISION",
  },
  {
    displayName: "Arts Division Meeting",
    value: "OTHER_MEETING_ARTS_DIVISION",
  },
  {
    displayName: "Healthcare Division Meeting",
    value: "OTHER_MEETING_HEALTHCARE_DIVISION",
  },
  {
    displayName: "MD Pillar Meeting",
    value: "OTHER_MEETING_MD_PILLAR",
  },
  {
    displayName: "Campus Group Meeting",
    value: "OTHER_MEETING_CAMPUS_GROUP",
  },
  {
    displayName: "All India Study Meeting",
    value: "OTHER_MEETING_ALL_INDIA_STUDY",
  },
  {
    displayName: "YWD Hope and Friendship Gathering",
    value: "OTHER_MEETING_YWD_HOPE_AND_FRIENDSHIP_GATHERING",
  },
  {
    displayName: "YMD Vanguard Academy",
    value: "OTHER_MEETING_YMD_VANGUARD_ACADEMY",
  },
  {
    displayName: "BSG HQ Gongyo and Tour Meeting",
    value: "OTHER_MEETING_BSG_HQ_GONGYO_AND_TOUR",
  },
  {
    displayName: "SBTG Visit by Friend and Family Meeting",
    value: "OTHER_MEETING_SBTG_VISIT_BY_FRIENDS_AND_FAMILY",
  },
  {
    displayName: "District Planning Meeting",
    value: "OTHER_MEETING_DISTRICT_PLANNING",
  },
  {
    displayName: "Source of Origin Meeting",
    value: "OTHER_MEETING_SOURCE_OF_ORIGIN",
  },
]
  .slice()
  .sort((a, b) =>
    a.displayName.localeCompare(b.displayName, "en", { sensitivity: "base" })
  );

export const PERMISSIONS = {
  // introduction
  INITIATE_INTRODUCTION: "introduction.create.initiate",
  VIEW_PENDING_INTRODUCTION: "introduction.read.pending",
  CANCEL_INTRODUCTION: "introduction.update.cancel",
  REJECT_INTRODUCTION: "introduction.update.reject",
  ASSIGN_TO_NEXT_LEVEL_INTRODUCTION: "introduction.update.assign_to_next_level",
  FINAL_ACCEPT_INTRODUCTION: "introduction.final_accept",

  // friend
  CREATE_NEW_ENTRY_FRIEND: "friend.create.new_friend",
  CONVERT_TO_FRIEND_MEMBER: "friend.update.convert_friend_to_member",
  CONVERT_TO_MEMBER_FRIEND: "friend.update.convert_to_member",
  INITIATE_TRANSFER_FRIEND: "friend.update.initiate_transfer",
  ASSIGN_TO_NEXT_LEVEL_FRIEND: "friend.update.assign_to_next_level",
  REJECT_FRIEND: "friend.update.reject_transfer",
  VIEW_PENDING_FRIEND: "friend.read.pending_transfer",
  FINAL_ACCEPT_FRIEND: "friend.update.final_accept",
  CANCEL_TRANSFER_FRIEND: "friend.update.cancel_transfer",
  DEACTIVATE_FRIEND: "friend.update.deactivate_friend",
  UPDATE_FRIEND: "friend.update.update_friend",

  // family
  CREATE_NEW_FAMILY: "family.create.new_family",
  UPDATE_FAMILY: "family.update.family",
  VIEW_FAMILY_DETAILS: "family.read.family_details",

  // member
  VIEW_SEARCH_MEMBER: "member.read.search_member",
  UPDATE_MEMBER: "member.update.update_member",
  UPDATE_MEMBER_DOB: "member.update.update_member.dateOfBirth",
  UPDATE_MEMBER_NAME: "member.update.update_member.name",
  INITIATE_TRANSFER_MEMBER: "member.update.initiate_transfer",
  VIEW_PENDING_MEMBER: "member.read.pending_transfer",
  FINAL_ACCEPT_MEMBER: "member.update.final_accept",
  REJECT_TRANSFER_MEMBER: "member.update.reject_transfer",
  CANCEL_TRANSFER_MEMBER: "member.update.cancel_transfer",
  ASSIGN_TO_NEXT_LEVEL_MEMBER: "member.update.assign_to_next_level",
  REACTIVATE_MEMBER: "member.update.reactivate",
  CREATE_NEW_ENTRY_MEMBER: "member.create.new_member",
  UPDATE_MEMBER_PROFILE_PHOTO: "member.update.profile_photo",
  DEACTIVATE_MEMBER: "member.update.deactivate_request",
  ADD_SUBSCRIPTION: "subscription.create.new_subscription",

  // attendance
  MARK_GOSHO: "attendance.update.mark_gosho",
  MARK_NHR: "attendance.update.mark_NHR",
  MARK_DISCUSSION: "attendance.update.mark_discussion",
  MARK_CUBS: "attendance.update.mark_cubs",
  MARK_YL: "attendance.update.mark_YL",
  MARK_SD: "attendance.update.mark_SD",
  MARK_YP: "attendance.update.mark_YP",

  // gohonzon
  VIEW_OKATAKI_APPLICATION_GOHONZON: "gohonzon.read.okataki_application",
  VIEW_OMAMORI_APPLICATION_GOHONZON: "gohonzon.read.omamori_application",
  VIEW_OKATAKI_APPLICATION_FOR_MEMBER_GOHONZON:
    "gohonzon.read.member_for_okataki_application",
  VIEW_OMAMORI_APPLICATION_FOR_MEMBER_GOHONZON:
    "gohonzon.read.member_for_omamori_application",
  CREATE_OKATAKI_APPLICATION_GOHONZON: "gohonzon.create.okataki_application",
  CREATE_OMAMORI_APPLICATION_GOHONZON: "gohonzon.create.omamori_application",
  UPDATE_OKATAKI_APPLICATION_GOHONZON: "gohonzon.update.okataki_application",
  UPDATE_OMAMORI_APPLICATION_GOHONZON: "gohonzon.update.omamori_application",
  VIEW_OKATAKI_APPLICATION_REMARK_GOHONZON:
    "gohonzon.read.okataki_application.remark",
  VIEW_OMAMORI_APPLICATION_REMARK_GOHONZON:
    "gohonzon.read.omamori_application.remark",
  UPDATE_OKATAKI_APPLICATION_OTP_GOHONZON:
    "gohonzon.update.okataki_application.otp",
  CANCEL_OKATAKI_GOHONZON: "gohonzon.update.okataki_application.cancel",
  CANCEL_OMAMORI_GOHONZON: "gohonzon.update.omamori_application.cancel",
  CREATE_BATCH_GOHONZON: "gohonzon.create.batch",
  VIEW_BATCH_GOHONZON: "gohonzon.read.batch",
  UPDATE_OKATAKI_APPLICATION_CONFERRAL_GOHONZON:
    "gohonzon.update.okataki_application.conferral",
  UPDATE_OMAMORI_APPLICATION_CONFERRAL_GOHONZON:
    "gohonzon.update.omamori_application.conferral",
  UPDATE_OKATAKI_APPLICATION_RETURN_GOHONZON:
    "gohonzon.update.okataki_application.return",
  UPDATE_OKATAKI_APPLICATION_INTERVIEW_GOHONZON:
    "gohonzon.update.okataki_application.interview",
  UPDATE_OMAMORI_APPLICATION_INTERVIEW_GOHONZON:
    "gohonzon.update.omamori_application.interview",
  CREATE_OKATAKI_APPLICATION_RETURN_REQUEST_GOHONZON:
    "gohonzon.create.okataki_application.return_request",
  CREATE_OMAMORI_APPLICATION_RETURN_REQUEST_GOHONZON:
    "gohonzon.create.omamori_application.return_request",
  ALLOTMENT_OKATAKI_APPLICATION_CANCEL_REQUEST_GOHONZON:
    "gohonzon.update.okataki_application.allotment_cancel_request",
  ALLOTMENT_OMAMORI_APPLICATION_CANCEL_REQUEST_GOHONZON:
    "gohonzon.update.omamori_application.allotment_cancel_request",
  UPDATE_OMAMORI_APPLICATION_RETURN_GOHONZON:
    "gohonzon.update.omamori_application.return",
  UPDATE_OMAMORI_APPLICATION_FINAL_INTERVIEW_GOHONZON:
    "gohonzon.update.omamori_application.finalInterview",
  UPDATE_OMAMORI_APPLICATION_RETURN_REQUEST_GOHONZON:
    "gohonzon.update.omamori_application.return_request",
  VIEW_SPECIAL_APPLICATION_GOHONZON: "gohonzon.read.special_application",
  UPDATE_SPECIAL_APPLICATION_CONFERRAL_GOHONZON:
    "gohonzon.update.special_application.conferral",
  UPDATE_SPECIAL_APPLICATION_RETURN_GOHONZON:
    "gohonzon.update.special_application.return",
  VIEW_SPECIAL_APPLICATION_REMARK_GOHONZON:
    "gohonzon.update.special_application.remark",
  CANCEL_SPECIAL_GOHONZON: "gohonzon.update.special_application.cancel",
  ALLOTMENT_SPECIAL_APPLICATION_CANCEL_REQUEST_GOHONZON:
    "gohonzon.update.special_application.allotment_cancel_request",
  ALLOTMENT_OKATAKI_APPLICATION_GOHONZON:
    "gohonzon.update.okataki_application.allotment",
  BATCH_HANDOVER_OKATAKI_APPLICATION_GOHONZON:
    "gohonzon.update.okataki_application.batch_handover",
  APPLICATION_HANDOVER_OKATAKI_APPLICATION_GOHONZON:
    "gohonzon.update.okataki_application.application_handover",
  ALLOTMENT_CANCEL_HANDOVER_OKATAKI_APPLICATION_GOHONZON:
    "gohonzon.update.okataki_application.allotment_cancel_handover",
  RETURN_REQUEST_HANDOVER_OKATAKI_APPLICATION_GOHONZON:
    "gohonzon.update.okataki_application.return_request_handover",
  ALLOTMENT_OMAMORI_APPLICATION_GOHONZON:
    "gohonzon.update.omamori_application.allotment",
  HANDOVER_OMAMORI_APPLICATION_GOHONZON:
    "gohonzon.update.omamori_application.handover",
  OTP_OMAMORI_APPLICATION_GOHONZON: "gohonzon.update.omamori_application.otp",
  ALLOTMENT_CANCEL_HANDOVER_OMAMORI_APPLICATION_GOHONZON:
    "gohonzon.update.omamori_application.allotment_cancel_handover",
  RETURN_REQUEST_HANDOVER_OMAMORI_APPLICATION_GOHONZON:
    "gohonzon.update.omamori_application.return_request_handover",
  VIEW_MEMBER_FOR_SPECIAL_APPLICATION_GOHONZON:
    "gohonzon.read.member_for_special_application",
  ALLOTMENT_SPECIAL_APPLICATION_GOHONZON:
    "gohonzon.update.special_application.allotment",
  HANDOVER_SPECIAL_APPLICATION_GOHONZON:
    "gohonzon.update.special_application.handover",
  OTP_SPECIAL_APPLICATION_GOHONZON: "gohonzon.update.special_application.otp",
  ALLOTMENT_CANCEL_HANDOVER_SPECIAL_APPLICATION_GOHONZON:
    "gohonzon.update.special_application.allotment_cancel_handover",
  GOHONZON_DIRECT_ENTRY: "gohonzon.create.direct_application",
  GOHONZON_CONSENT_LINK: "gohonzon.read.consent_link",
  RESEND_GOHONZON_CONSENT: "gohonzon.update.generate_consent",
  GOHONZON_TRACKING: "gohonzon.read.application.tracking",
  UPDATE_GOHONZON_APPLICATION: "gohonzon.update.application_update",

  // appointment
  CREATE_APPLICATION_FOR_APPOINTMENT: "appointment.create.application",
  VIEW_RECCOMNDED_APPLICATION_FOR_APPOINTMENT:
    "appointment.read.application.recommend",
  VIEW_APPROVE_APPLICATION_FOR_APPOINTMENT:
    "appointment.read.application.approve",
  VIEW_LIST_APPLICATION_FOR_APPOINTMENT:
    "appointment.read.application.appointment_list",
  VIEW_APPLICATION_FOR_APPOINTMENT:
    "appointment.read.application.initiate_recommend_approve_interview_reject_appoint",
  INTERVIEW_APPOINTMENT: "appointment.update.interview",
  UPDATE_MARK_APPOINTMENT: "appointment.update.mark_appointment",
  SPLIT_CHECK_STRUCTURE_CREATE: "split.create.structure",
  SPLIT_CHECK_STRUCTURE_UPDATE: "split.update.structure",
  REJECT_APPOINTMENT: "appointment.update.reject",
  REVIEW_APPOINTMENT: "appointment.update.review",
  REVIEW_PARTIAL_APPOINTMENT: "appointment.update.review.partial_recommend",
  VIEW_PARTIAL_APPLICATION_FOR_APPOINTMENT:
    "appointment.read.application.partial_approve",
  CREATE_APPLICATION_FOR_DIRECT_APPOINTMENT:
    "directAppointment.create.application",
  VIEW_APPLICATION_FOR_DIRECT_APPOINTMENT: "directAppointment.read.application",
  VIEW_APPLICATION_FOR_ADHOC_APPOINTMENT:
    "directAppointment.read.adhoc_application",
  VIEW_APPLICATION_FOR_AAC_FIRST_APPROVED:
    "appointment.read.application.aac_first_approved",
  VIEW_APPLICATION_FOR_AAC_SECOND_APPROVED:
    "appointment.read.application.aac_second_approved",

  RESEND_CONSENT_LINK: "appointment.update.generate_consent",

  FORCE_PUSH_APPLICATION: "appointment.update.push_application",
  CANCEL_APPOINTMENT_APPLICATION: "appointment.update.application.cancel",
  ADMIN_FORCE_PUSH: "appointment.update.direct_push_application",
  VIEW_STRUCTURE_LEADERS_SPECIAL_GROUP:
    "member.read.structure_leaders.special_group",
  CREATE_DIRECT_APPOINTMENT_SPECIAL_GROUP:
    "directAppointment.create.application.special_group",
  READ_SPECIAL_GROUP_APPLICATIONS:
    "directAppointment.read.application.special_group",
  // announcement
  CREATE_ANNOUNCEMENT: "announcement.create.cycle",
  VIEW_ANNOUNCEMENT: "announcement.read.cycle",
  UPDATE_ANNOUNCEMENT: "announcement.update.cycle",

  // Show ZOne Locator in Assign Modals
  SHOW_ZONELOCATOR_INTRODUCTION: "introduction.update.use_zone_locator",
  SHOW_ZONELOCATOR_FRIEND: "friend.update.use_zone_locator",
  SHOW_ZONELOCATOR_MEMBER: "member.update.use_zone_locator",

  // Reports
  MEMBER_GENERAL_REPORT: "report.member.general_report",
  FRIEND_GENERAL_REPORT: "report.friend.general_report",
  ATTENDANCE_REPORT_STATS: "report.read.attendance_stats",
  CONNECTION_REPORT_STATS: "report.read.connection_statistic",
  SUBSCRIPTION_REPORT: "report.subscription.general_report",
  FRIEND_AGEING_REPORT: "report.friend.ageing_report",
  FRIEND_SUMMARY_REPORT: "report.friend.summary",
  FRIEND_CHANGE_TO_MEMBER_TREND: "report.friend.change_to_member_trend",
  FRIEND_TO_MEMBER_GROWTH: "report.friend.friend_to_member_growth",
  FRIEND_NEW_FRIEND_TREND: "report.friend.new_friend_trend",
  SUBSCRIPTION_REPORT_TREND: "report.subscription.trend_report",
  SUBSCRIPTION_REPORT_MIS: "report.subscription.mis_report",
  SUBSCRIPTION_REPORT_EXPIRED: "report.subscription.expired",
  SUBSCRIPTION_REPORT_NEAR_TO_EXPIRY: "report.subscription.near_to_expiry",

  // Graduation
  SPECIAL_GROUP_INDUCTION: "special_group.read.induction",
  SPECIAL_GROUP_GRADUATION: "special_group.update.graduation",
  SPECIAL_GROUP_GRADUATION_CREATE: "division_graduation.create.graduation",
  SPECIAL_GROUP_INDUCTION_CREATE: "special_group.create.induction",
  SEARCH_SPECIAL_GROUP: "special_group.read.member_search",
  DIVISION_GRADUATION: "division_graduation.create.graduation",

  // Emailer
  CREATE_EMAIL_TEMPLATE: "emailer.create.email_template",
  READ_EMAIL_TEMPLATE: "emailer.read.email_template",
  SEND_EMAIL: "emailer.create.send_email",
  COPY_TEMPLATE: "emailer.update.duplicate_template",
  DELETE_ALL_RECIPIENTS: "emailer.update.delete_all_recipients",
  SEND_EMAIL_BUTTON: "emailer.update.send_email",
  ADD_RECIPIENTS: "emailer.update.add_recipients",
  UPDATE_TEMPlATE: "emailer.update.template",

  // HDC
  CREATE_HDC_HELPDESK: "hdc.create.helpdesk",
  CREATE_HDC_AREA: "hdc.create.area",
  CREATE_HDC_ZONE: "hdc.create.zone",
  CREATE_HDC_HELPDESK_ADMIN: "hdc.create.helpdeskAdmin",

  // File Uploads
  CREATE_CONTENT: "content.create.content",
  UPDATE_CONTENT: "content.update.content",
  DELETE_CONTENT: "content.delete.content",
  READALL_CONTENT: "content.read.all_content",

  // Examination
  SEARCH_EXAMINATION_MEMBERS: "report.examination.read.search_eligible",
  CREATE_EXAMINATION_MEMBERS: "report.examination.create.search_eligible",
  SEARCH_EXAMINATION_APPLIED_MEMBERS: "report.examination.read.search_applied",
  CREATE_EXAMINATION_APPLIED_MEMBERS:
    "report.examination.create.search_applied",
  DEACTIVATE_EXAMINATION_APPLIED_MEMBER:
    "examination.update.application.deactivate",
  EXAM_DIRECT_ENTRY: "examination.create.direct_application",

  REMOVE_EXAMINATION_APPLIED_MEMBERS: "examination.update.application.remove",
  UPDATE_EXAMINATION_APPLIED_MEMBERS: "examination.update.application",

  // Ticket System
  CREATE_NEW_TICKET: "ticketing.create.application",
  UPDATE_TICKET: "ticketing.read.application",
  VIEW_TICKET_DETAILS: "ticketing.update.application",

  // User ROles
  ROLE_ASSIGNMENT: "role.create.assign_role",

  // Control Panel
  UNMARKED_STRUCTURE_EMAIL: "meeting.create.unmarked_structure_email",
};

export const AppliedFilterLabelMap = {
  memberId: "Member ID",
  fullName: "Member Name",
  roleId: "Role",
  mobileNumber: "Phone Number",
  emailId: "Email Id",
  address: "Address",
  pincode: "Pin Code",
  state: "State",
  city: "City",
  divisionId: "Division",
  subdivisionId: "Sub Division",
  specialGroupId: "Special Group",
  dateOfBirth: "Date of Birth",
  dateOfJoining: "Date of Joining",
  professionsId: "Profession",
  professionSpecialGroup: "Profession Special Group",
  appointmentFrom: "Appointment Date",
  dualPositionIds: "Positions",
  mainlinePositionIds: "Mainline Position",
  subLeadershipPosition: "Subdivision Leadership Position",
  subDivisionAppointmentFrom: "Sub-Division Appointment Date",
  isGohonzon: "Gohonzon Member",
  conferralFrom: "Conferral Date",
  isOmamoriGohonzon: "Omamori Gohonzon",
  unsubscribe: "Unsubscribe (Wrong Email ID)",
  areaId: "Area",
  zoneId: "Zone",
  regionId: "Region",
  chapterId: "Chapter",
  districtId: "District",
  blockId: "Block",
  application: "Application Date",
  allotment: "Allotment Date",
  conferred: "Conferred Date",
  appointedAt: "Appointment Date",
  conferralDate: "Conferral Date",
  gohonzonTypes: "Gohonzon Type",
  meetingType: "Meeting Type",
  honoraryDistrictChief: "honoraryDistrictChief",
  memberStatus: "Status",
  appliedFor: "Applied For",
  status: "Status",
  type: "Subscription Type",
  subscriptionNumber: "Subscription Number",
  startAt: "Start Date",
  endAt: "End Date",
  date: "Period",
  examDetailId: "Exam Level",
  specialGroupAppointments: "Special Group Appointments",
};

export const DATES = [
  "dateOfBirthFrom",
  "dateOfJoiningFrom",
  "dateFrom",
  "appointedAtFrom",
  "conferralDateFrom",
  "applicationFrom",
  "allotmentFrom",
  "conferredFrom",
  "from",
  "startAtFrom",
  "endAtFrom",
];
export const EXCLUDE_DATES = [
  "dateOfBirthTo",
  "dateOfJoiningTo",
  "dateTo",
  "appointedAtTo",
  "conferralDateTo",
  "applicationTo",
  "allotmentTo",
  "conferredTo",
  "to",
  "startAtTo",
  "endAtTo",
];
export const ALL_DATES = [...DATES, ...EXCLUDE_DATES];
export const EVENT_NAME = "close-popover";
export const CLOSE_DRAWER_EVENT_NAME = "close-drawer";
export const OPEN_DRAWER_EVENT_NAME = "open-drawer";
export const OPEN_SAVE_ALERT_EVENT_NAME = "open-save-alert";

export const OS_DROPDOWN_KEYS = [
  "areaId",
  "zoneId",
  "regionId",
  "chapterId",
  "districtId",
  "blockId",
];

export const DROPDOWN_KEYS = [
  "city",
  "state",
  "divisionId",
  "subdivisionId",
  "specialGroupId",
  "professionsId",
  "periodDate",
  "roleId",
  "positionId",
];

export const OS_REDUX_KEY_MAPPER = {
  areaId: "zones",
  zoneId: "regions",
  regionId: "chapters",
  chapterId: "districts",
  districtId: "blocks",
};

export const DROPDOWN_REDUX_KEY_MAPPER = {
  areaId: "areas",
  zoneId: "zones",
  regionId: "regions",
  chapterId: "chapters",
  districtId: "districts",
  blockId: "blocks",
  city: "cities",
  state: "states",
  divisionId: "divisions",
  subdivisionId: "subDivisions",
  professionsId: "profession",
  specialGroupId: "specialGroups",
  periodDate: "attendanceDate",
  roleId: "roles",
};

export const TRANSFER_OS_DROPDOWN_KEYS = [
  "initiatorAreaId",
  "initiatorZoneId",
  "initiatorRegionId",
  "initiatorChapterId",
  "initiatorDistrictId",
  "initiatorBlockId",
  "targetAreaId",
  "targetZoneId",
  "targetRegionId",
  "targetChapterId",
  "targetDistrictId",
  "targetBlockId",
];

export const TRANSFER_DROPDOWN_REDUX_KEY_MAPPER = {
  initiatorAreaId: "areas",
  initiatorZoneId: "zones",
  initiatorRegionId: "regions",
  initiatorChapterId: "chapters",
  initiatorDistrictId: "districts",
  initiatorBlockId: "blocks",
  targetAreaId: "areas",
  targetZoneId: "zones",
  targetRegionId: "regions",
  targetChapterId: "chapters",
  targetDistrictId: "districts",
  targetBlockId: "blocks",
  city: "cities",
  state: "states",
  divisionId: "divisions",
  subdivisionId: "subDivisions",
};

export const OS_KEYS = [
  "districtId",
  "chapterId",
  "regionId",
  "zoneId",
  "areaId",
];

export const FULL_OS_KEYS = [
  "blockId",
  "districtId",
  "chapterId",
  "regionId",
  "zoneId",
  "areaId",
];

export const CHEIF_ACCESS_MAP = {
  districtSI: "districtSI",
  chapterSI: "chapterSI",
  regionSI: "regionSI",
  zoneSI: "zoneSI",
  areaSI: "areaSI",
  helpDesk: "helpDesk",
  districtLeader: "districtLeader",
  chapterLeader: "chapterLeader",
  regionLeader: "regionLeader",
  zoneLeader: "zoneLeader",
  areaLeader: "areaLeader",
  nationalLeader: "nationalLeader",
  helpDeskAdmin: "helpDeskAdmin",
  nationalSI: "nationalSI",
};

export const ChiefSIToIdMapper = {
  districtSI: "districtId",
  chapterSI: "chapterId",
  regionSI: "regionId",
  zoneSI: "zoneId",
  areaSI: "areaId",
};

export const ROLES_KEY_MAPPER = {
  districtSI: OS_KEYS.reverse(),
  districtLeader: OS_KEYS.reverse(),
  districtDeputySI: OS_KEYS.reverse(),
  chapterSI: OS_KEYS.slice(0, -1),
  chapterLeader: OS_KEYS.slice(0, -1),
  chapterDeputySI: OS_KEYS.slice(0, -1),
  regionSI: OS_KEYS.slice(0, -2),
  regionLeader: OS_KEYS.slice(0, -2),
  regionDeputySI: OS_KEYS.slice(0, -2),
  zoneSI: OS_KEYS.slice(0, -3),
  zoneLeader: OS_KEYS.slice(0, -3),
  zoneDeputySI: OS_KEYS.slice(0, -3),
  areaSI: OS_KEYS.slice(0, -4),
  areaLeader: OS_KEYS.slice(0, -4),
  areaDeputySI: OS_KEYS.slice(0, -4),
  helpDesk: [],
  nationalLeader: [],
  helpDeskAdmin: [],
  nationalSI: [],
};

export const INTEGER_KEYS = [
  "memberId",
  "pincode",
  "state",
  "city",
  "divisionId",
  "subdivisionId",
  "professionsId",
  "specialGroupId",
  "roleId",
];

export const GOHONZON_TYPE_OPTIONS = [
  {
    key: "GOHONZON",
    value: "OKATAKI_GOHONZON",
  },
  // {
  //   key: "OMAMORI",
  //   value: "OMAMORI_GOHONZON",
  // },
  // {
  //   key: "SPECIAL",
  //   value: "SPECIAL_GOHONZON",
  // },
];

export const GOHONZON_TYPE = {
  OKATAKI_GOHONZON: "OKATAKI_GOHONZON",
  OMAMORI_GOHONZON: "OMAMORI_GOHONZON",
  SPECIAL_GOHONZON: "SPECIAL_GOHONZON",
};

export const INTRODUCTION_TYPE = "introduction";
export const MEMBER_TYPE = "member";
export const FRIEND_TYPE = "friend";
export const ACTIVE = "ACTIVE";
export const DEACTIVATED = "DEACTIVATED";

export const DEACTIVATE_REASONS = [
  {
    displayName: "Eternal Comrades",
    value: "ETERNAL_COMRADES",
  },
  // {
  //   displayName: "Not interested in practicing",
  //   value: "NOT_INTERESTED_IN_PRACTICING",
  // },
  // {
  //   displayName: "Not traceable",
  //   value: "NOT_TRACEABLE",
  // },
  {
    displayName: "Overseas Comrades",
    value: "OVERSEAS_COMRADES",
  },
  // {
  //   displayName: "Disciplinary Action",
  //   value: "DISCIPLINARY_ACTION",
  // },
  // {
  //   displayName: "Gohonzon Return",
  //   value: "GOHONZON_RETURN",
  // },
  {
    displayName: "Duplicate entry",
    value: "DUPLICATE_MEMBER",
  },
];

export const ETERNAL_COMRADES_CASES = [
  {
    displayName: "Gohonzon Returned",
    value: "GOHONZON_RETURNED",
  },
  {
    displayName: "Gohonzon Transferred",
    value: "GOHONZON_TRANSFERRED_TO_PRACTICING_MEMBER",
  },
  {
    displayName: "Gohonzon Retained",
    value: "GOHONZON_RETAINED_BY_NON_PRACTICING_MEMBER",
  },
];

export const DUPLICATE_REASONS_CHECKBOX = [
  {
    displayName: "Appointment",
    getValue: "shouldMoveAppointment",
    type: "CHECKBOX",
    name: "checkbox-1",
  },
  {
    displayName: "Awards",
    getValue: "shouldMoveAward",
    type: "CHECKBOX",
    name: "checkbox-2",
  },
  {
    displayName: "Examination",
    getValue: "shouldMoveExam",
    type: "CHECKBOX",
    name: "checkbox-3",
  },
  {
    displayName: "Family",
    getValue: "shouldMoveFamily",
    type: "CHECKBOX",
    name: "checkbox-4",
  },
  {
    displayName: "Gohonzon",
    getValue: "shouldMoveGohonzon",
    type: "CHECKBOX",
    name: "checkbox-5",
  },
  {
    displayName: "Subscription",
    getValue: "shouldMoveSubscription",
    type: "CHECKBOX",
    name: "checkbox-6",
  },
  {
    displayName: "Attendance",
    getValue: "shouldMoveAttendance",
    type: "CHECKBOX",
    name: "checkbox-7",
  },
];

export const MARK_ATTENDANCE = [
  // {
  //   displayName: "FAMILY ID",
  //   key: "familyId",
  // },
  {
    displayName: "AREA",
    key: "area",
  },

  {
    displayName: "ZONE",
    key: "zone",
  },
  {
    displayName: "REGION",
    key: "region",
  },
  {
    displayName: "FAMILY MEMBERS",
    key: "familyAddress",
  },
  {
    displayName: "ADDRESS",
    key: "address",
  },
  {
    displayName: "ACTION",
    key: "action",
  },
];

export const Constants = {
  MIN_PAGE_SIZE: 10,
  MAX_PAGE_SIZE: 20,
  DEFAULT_PAGE_SIZE: 10,
  PLUS: "plus",
};

export const ConstantsAppointment = {
  MIN_PAGE_SIZE: 4,
  MAX_PAGE_SIZE: 20,
  DEFAULT_PAGE_SIZE: 4,
  PLUS: "plus",
};

export const OTP_LEN = 6;

export const RELATION_OPTIONS = [
  { key: "Mother", value: "MOTHER" },
  { key: "Father", value: "FATHER" },
  { key: "Wife", value: "WIFE" },
  { key: "Husband", value: "HUSBAND" },
  { key: "Daughter", value: "DAUGHTER" },
  { key: "Son", value: "SON" },
  { key: "Sister", value: "SISTER" },
  { key: "Brother", value: "BROTHER" },
  { key: "Grand Mother", value: "GRANDMOTHER" },
  { key: "Grand Father", value: "GRANDFATHER" },
  { key: "Mother in law", value: "MOTHER_IN_LAW" },
  { key: "Father in law", value: "FATHER_IN_LAW" },
  { key: "Daughter in law", value: "DAUGHTER_IN_LAW" },
  { key: "Son in law", value: "SON_IN_LAW" },
  { key: "Niece", value: "NIECE" },
  { key: "Nephew", value: "NEPHEW" },
];

export const Appointment = {
  MAINLINE_POSITION: "MAINLINE_POSITION",
  DEPUTY_POSITION: "DEPUTY_POSITION",
};

export const ChiefNameToPositionMapper = {
  [CHEIF_ACCESS_MAP.districtSI]: [],
  [CHEIF_ACCESS_MAP.chapterSI]: [26, 50],
  [CHEIF_ACCESS_MAP.regionSI]: [29, 30],
  [CHEIF_ACCESS_MAP.zoneSI]: [27, 28],
  [CHEIF_ACCESS_MAP.areaSI]: [51, 59],
};

export const TABLE_ROUTES = [
  ROUTES.INTRODUCTION_VIEW.path,
  ROUTES.FRIEND_TRANSFER.path,
  ROUTES.MEMBER_TRANSFER.path,
  ROUTES.MEMBER_DETAIL.path,
  ROUTES.FRIEND_DETAIL.path,
];

export const AlertStatus = {
  ERROR: "error",
  SUCCESS: "success",
  INFO: "info",
  WARNING: "warning",
};

export const [DROPDOWN, TEXTFIELD, TEXTLABEL, AUTOCOMPLETE] = [
  "dropdown",
  "textfield",
  "textlabel",
  "autocomplete",
];

export const MEMBER_OPTIONS = [
  { key: "Yes", value: "YES" },
  { key: "No", value: "NO" },
];

export const AppliedFilterFriendLabelMap = {
  friendId: "Friend ID",
  fullName: "Friend Name",
  mobileNumber: "Phone Number",
  emailId: "Email Id",
  address: "Address",
  pincode: "Pin Code",
  state: "State",
  city: "City",
  divisionId: "Division",
  subdivisionId: "Sub Division",
  dateOfBirth: "Date of Birth",
  dateOfJoining: "Date of Joining",
  profession: "Profession",
  professionSpecialGroup: "Profession Special Group",
  appointmentFrom: "Appointment Date",
  positions: "Positions",
  mainlinePositions: "Mainline Position",
  subLeadershipPosition: "Subdivision Leadership Position",
  subDivisionAppointmentFrom: "Sub-Division Appointment Date",
  isGohonzon: "Gohonzon Member",
  conferralFrom: "Conferral Date",
  isOmamoriGohonzon: "Omamori Gohonzon",
  unsubscribe: "Unsubscribe (Wrong Email ID)",
  areaId: "Area",
  zoneId: "Zone",
  regionId: "Region",
  chapterId: "Chapter",
  districtId: "District",
  blockId: "Block",
  initiatorAreaId: "Initiator Area",
  initiatorZoneId: "Initiator Zone",
  initiatorRegionId: "Initiator Region",
  initiatorChapterId: "Initiator Chapter",
  initiatorDistrictId: "Initiator District",
  initiatorBlockId: "Initiator Block",
  targetAreaId: "Target Area",
  targetZoneId: "Target Zone",
  targetRegionId: "Target Region",
  targetChapterId: "Target Chapter",
  targetDistrictId: "Target District",
  targetBlockId: "Target Block",
  periodDate: "Period",
  meetingType: "Meeting Type",
  date: "Period",
  divisionIds: "Division",
};

export const AppliedIntroductionFilterLabelMap = {
  introductionId: "Introduction ID",
  fullName: "Introduction Name",
  mobileNumber: "Phone Number",
  emailId: "Email Id",
  areaId: "Area",
  zoneId: "Zone",
  regionId: "Region",
  chapterId: "Chapter",
  districtId: "District",
  blockId: "Block",
  initiatorAreaId: "Initiator Area",
  initiatorZoneId: "Initiator Zone",
  initiatorRegionId: "Initiator Region",
  initiatorChapterId: "Initiator Chapter",
  initiatorDistrictId: "Initiator District",
  initiatorBlockId: "Initiator Block",
  targetAreaId: "Target Area",
  targetZoneId: "Target Zone",
  targetRegionId: "Target Region",
  targetChapterId: "Target Chapter",
  targetDistrictId: "Target District",
  targetBlockId: "Target Block",
};

export const AppliedMemberFilterLabelMap = {
  memberId: "Member ID",
  fullName: "Member Name",
  mobileNumber: "Phone Number",
  emailId: "Email Id",
  areaId: "Area",
  zoneId: "Zone",
  regionId: "Region",
  chapterId: "Chapter",
  districtId: "District",
  blockId: "Block",
  initiatorAreaId: "Initiator Area",
  initiatorZoneId: "Initiator Zone",
  initiatorRegionId: "Initiator Region",
  initiatorChapterId: "Initiator Chapter",
  initiatorDistrictId: "Initiator District",
  initiatorBlockId: "Initiator Block",
  targetAreaId: "Target Area",
  targetZoneId: "Target Zone",
  targetRegionId: "Target Region",
  targetChapterId: "Target Chapter",
  targetDistrictId: "Target District",
  targetBlockId: "Target Block",
};
export const AppliedFilterLabelMapEmailer = {
  id: "Member ID",
  fullName: "Member Name",
  mobileNumber: "Phone Number",
  emailId: "Email Id",
  addressLine1: "Address",
  pincode: "Pin Code",
  stateId: "State",
  cityId: "City",
  divisionId: "Division",
  subdivisionId: "Sub Division",
  dateOfBirth: "Date of Birth",
  dateOfJoining: "Date of Joining",
  appointedAt: "Appointment Date",
  professionsId: "Profession",
  professionSpecialGroup: "Profession Special Group",
  appointmentFrom: "Appointment Date",
  dualPositionIds: "Positions",
  mainlinePositionIds: "Mainline Position",
  subLeadershipPosition: "Subdivision Leadership Position",
  subDivisionAppointmentFrom: "Sub-Division Appointment Date",
  isGohonzon: "Gohonzon Member",
  gohonzonTypes: "Gohonzon Types",
  conferralDate: "Conferral Date",
  isOmamoriGohonzon: "Omamori Gohonzon",
  unsubscribe: "Unsubscribe (Wrong Email ID)",
  areaId: "Area",
  zoneId: "Zone",
  regionId: "Region",
  chapterId: "Chapter",
  districtId: "District",
  blockId: "Block",
};

export const GOHONZON_TRANSACTION_TYPE_OPTIONS = [
  {
    key: "Allotment",
    value: "ALLOTMENT",
  },
  {
    key: "Retuened Non Conferral",
    value: "RETURNED_NON_CONFERRAL",
  },
  {
    key: "Returned Others",
    value: "RETURNED_OTHERS",
  },
  {
    key: "Replacement",
    value: "REPLACEMENT",
  },
  {
    key: "Addition HQ",
    value: "ADDITION_HQ",
  },
];

export const GOHONZON_OPTIONS = [
  {
    key: "Gohonzon",
    value: "OKATAKI_GOHONZON",
  },
  {
    key: "Omamori",
    value: "OMAMORI_GOHONZON",
  },
  {
    key: "Special",
    value: "SPECIAL_GOHONZON",
  },
];
